import React, { useEffect, useState } from 'react'
import CardCustom from '../../custom/card-custom'
import { BsArrowClockwise, BsChevronLeft, BsSearch } from 'react-icons/bs'
import { createSearchParams, useNavigate } from 'react-router-dom'
import {
  EMP_TRANSFER,
  EMP_TRANSFER_DETAIL_HISTORY
} from '../../../router/routes'
import {
  Button,
  Table,
  Image,
  Tooltip,
  ButtonToolbar,
  OverlayTrigger,
  Form,
  InputGroup
} from 'react-bootstrap'
import SpinnerLoading from '../../spinner-loading'
import NavTitle from '../../nav-title'
import moment from 'moment'
import { getTransferHistoryAPI } from '../../../services/transfer'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { BODY, PAGE } from '../../../Constants'
import detailImg from '../../../images/Detail.svg'
import PickerRangeCustom from '../../datepicker-between-custom'
import { useDebounce } from '@react-hook/debounce'
import Autocomplete from '../../custom/autocomplete'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'

export default function TransferHistoryPage() {
  const {
    control,
    setValue,
    formState: { errors }
  } = useForm()
  const roleId = useSelector((state) => state.roleReducer.role)

  const [search, setSearch] = useDebounce('', 1000)
  const [isLoading, setIsLoading] = useState(true)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const navigate = useNavigate()
  const [numLoad, setNumLoad] = useState(1)

  const [page, setPage] = useState(1)
  const [totalLimits, setTotalLimits] = useState(2)
  const [totalRows, setTotalRows] = useState(0)
  const [dataTable, setDataTable] = useState([])

  const typeId = [
    {
      id: 1,
      name: 'Promote'
    },
    {
      id: 2,
      name: 'Transfer Org'
    }
  ]
  const options = typeId.map((type) => ({
    label: type.name,
    value: type.id
  }))
  const [typeIds, setTypeIds] = useState()

  useEffect(() => {
    const param = {
      page: numLoad !== 1 ? 1 : page,
      effDateStart: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
      effDateEnd: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
      searchs: search ? search : '',
      transferTypeId: typeIds ? typeIds : ''
    }
    setPage(numLoad !== 1 ? 1 : page)
    getTransferHistory(param)
    setNumLoad(numLoad + 1)
  }, [startDate, endDate, typeIds, search])

  const getTransferHistory = async (param) => {
    const res = await getTransferHistoryAPI(param)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      setDataTable(res.result)
      setTotalRows(res.totalRows)
      setTotalLimits(res.totalLimits)
    } else {
      setDataTable([])
      setTotalRows(0)
      setTotalLimits(0)
    }
  }

  const clearSearch = () => {
    setStartDate('')
    setEndDate('')
    setSearch('')
    setTypeIds('')
    setValue('searchs', '')
    setValue('typeIdSearch', '')
    setValue('effectiveDate', '')

    const param = {
      page: 1
    }
    setPage(1)
    localStorage.setItem(BODY, '{}')
    localStorage.setItem(PAGE, 1)
    getTransferHistory(param)
  }

  const handleDetail = (d) => {
    navigate(
      {
        pathname: EMP_TRANSFER_DETAIL_HISTORY,
        search: `?${createSearchParams({
          transferNo: d.transfer_no,
          type: d.transfer_type
        })}`
      },
      { replace: true }
    )
  }

  return (
    <>
      <NavTitle>
        <div
          className={'h4 text-muted my-auto text-decoration-none pointer-event'}
          onClick={() => navigate(EMP_TRANSFER)}
        >
          <BsChevronLeft /> Back
        </div>
      </NavTitle>
      <CardCustom border="0" className="h-full">
        <div
          className="d-flex justify-content-between p-3 col-12"
          style={{ flexWrap: 'wrap' }}
        >
          <span className="my-auto text-decoration-none text-primary col-4"></span>
          <div className="col-8 d-flex justify-content-end gap-2">
            <span className=" mt-4 pt-1 fw-light small">
              <Form.Group className="" style={{ minWidth: 300 }}>
                <Controller
                  name={'searchs'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputGroup className="">
                      <InputGroup.Text className="bg-white border-end-0  text-muted">
                        <BsSearch />
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="ID Transfer/ Name"
                        onChange={(e) => {
                          onChange(e) // Update the field value
                          setSearch(e.target.value) // Update the search term
                        }}
                        value={value} // Set the value of the input field
                        className="border-start-0 ps-0 placeholder-text"
                      />
                    </InputGroup>
                  )}
                />
              </Form.Group>
            </span>
            <span className="m-2 fw-light small w-100">
              Transfer Type
              <span
                style={{
                  fontSize: '12px'
                }}
              >
                <Controller
                  name={'typeIdSearch'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Autocomplete
                      defaultValue={'All'}
                      options={options}
                      value={value}
                      onChange={(data) => {
                        onChange(data)
                        setTypeIds(data?.value)
                      }}
                    />
                  )}
                />
              </span>
            </span>

            <span className="m-2 fw-light small w-100">
              Effective Date{' '}
              <Controller
                name={'effectiveDate'}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <PickerRangeCustom
                    style={{ width: '300px' }}
                    onChange={(date) => {
                      if (date.length > 1) {
                        const st = moment(date[0]).format('YYYY-MM-DD')
                        const en = moment(date[1]).format('YYYY-MM-DD')
                        onChange(date)
                        setStartDate(st)
                        setEndDate(en)
                      } else if (date.length === 0) {
                        onChange(null)
                        setStartDate(null)
                        setEndDate(null)
                      }
                    }}
                    value={value}
                  />
                )}
              />
            </span>

            <span className="mt-4 p-1">
              <Button
                size="sm"
                type="button"
                variant="light"
                onClick={() => clearSearch()}
                className="text-primary "
              >
                <BsArrowClockwise />
              </Button>
            </span>
          </div>
        </div>

        <Table>
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px' }}
          >
            <tr className="fw-light font-title-table">
              <th className="fw-normal">No</th>
              <th
                className="fw-normal border-0"
                style={{ whiteSpace: 'nowrap' }}
              >
                ID Transfer
              </th>
              <th className="fw-normal" style={{ minWidth: '2rem' }}>
                Name
              </th>
              <th
                className="fw-normal border-0"
                style={{ whiteSpace: 'nowrap' }}
              >
                Transfer Type
              </th>
              <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                Edit By
              </th>

              <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                Edit Date
              </th>
              <th className="fw-normal " style={{ whiteSpace: 'nowrap' }}>
                Effective Date
              </th>
              <th className="fw-normal " style={{ whiteSpace: 'nowrap' }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="mb-3 fw-light" key={i}>
                    <td>
                      {page * totalLimits - totalLimits + i + 1}
                      {/* { i + 1} */}
                    </td>
                    <td>
                      <p className="font-small-2">{d?.transfer_no || '-'}</p>
                    </td>
                    <td>
                      <p className="font-small-2">
                        {' '}
                        {d?.name_en || '-'} {d?.surname_en}
                      </p>
                    </td>
                    <td>
                      <p className="font-small-2">{d?.transfer_type || '-'}</p>
                    </td>
                    <td lg={1} className="my-auto">
                      <p className="mb-0  font-small-2">
                        {d?.insert_by || '-'}
                      </p>
                    </td>

                    <td lg={1} className="my-auto">
                      <p className="mb-1  font-small-2">
                        {moment(d.insert_date).format('DD/MM/YYYY')}
                      </p>
                    </td>
                    <td lg={2} className="my-auto">
                      <p className="mb-1  font-small-2">
                        {moment(d.effective_date).format('DD/MM/YYYY')}{' '}
                      </p>
                    </td>
                    <td className="my-auto">
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-detail">Detail</Tooltip>
                          }
                        >
                          <Button
                            variant="outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              handleDetail(d)
                            }}
                          >
                            <Image
                              src={detailImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="mb-0">
                  <td className="text-center small" colSpan={13}>
                    {roleId
                      ? '- ไม่มีข้อมูล -'
                      : '- ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -'}
                  </td>
                </tr>
              )
            ) : (
              <tr className="mb-0">
                <td className="text-center" colSpan={13}>
                  <SpinnerLoading />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="pt-3" style={{ bottom: '0px', zIndex: 999 }}>
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={async (page) => {
              const param = {
                page,
                effDateStart: startDate
                  ? moment(startDate).format('YYYY-MM-DD')
                  : '',
                effDateEnd: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
                searchs: search ? search : '',
                transferTypeId: typeIds ? typeIds : ''
              }

              await getTransferHistory(param)
              setPage(page)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </>
  )
}
